// src/components/walkthrough/drawerControl.js
//
// Lets the walkthrough hold PageLayout's drawer open below 1280px, for the
// steps whose element is only in the drawer (SPEC decision 7). PageLayout owns
// the drawer; this is the one thing it listens to from outside.
//
// While held, the drawer is rendered as a persistent drawer rather than a
// modal one (PLAN decision 5, as built): two modals would fight over focus and
// Esc, and the later one would hide the walkthrough's card from screen readers.

import { useEffect, useState } from "react";

let held = false;
const listeners = new Set();

/** Open (true) or release (false) the drawer for the walkthrough. */
export function holdDrawer(open) {
  if (held === open) return;
  held = open;
  listeners.forEach((listener) => listener(held));
}

/** Whether the walkthrough is holding the drawer open, live. */
export function useHeldDrawer() {
  const [open, setOpen] = useState(held);
  useEffect(() => {
    listeners.add(setOpen);
    setOpen(held);
    return () => listeners.delete(setOpen);
  }, []);
  return open;
}
